import { render } from "./warning.vue?vue&type=template&id=007342e6&lang=pug"
import script from "./warning.vue?vue&type=script&setup=true&lang=js"
export * from "./warning.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__